import React from "react";
import Navbar from "../Components/NavMenu";
import Question from "../Components/Question";
import Settings from "../Components/Settings";
import "../App.css";

function AssessmentPreview() {

  const background={ backgroundColor: "#F7F7F7",
    borderRadius: "10px",paddingTop: "60px",
  };

  const user={
    name:"Harry"
  };

  return (
    <div className="App">
      <Navbar />
      <div className="container" style={background}>
        <div className="container mt-4">
          <div className="row">
            <div className="col-md-9">
              <Question />
            </div>
            <div
              className="container col-md-3 p-2 mt-3"
              style={{ backgroundColor: "#ffffff", borderRadius: "10px" }}
            >
              <Settings user={user} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AssessmentPreview;
